import React, { useState, useRef, useEffect } from "react";

/**
 * Year-only range picker.
 *
 * publication_year is an integer year column on the backend, so the filter is
 * a year — a full date was never used.
 */
export const YEAR_OPTIONS = (() => {
  const now = new Date().getFullYear();
  return Array.from({ length: now - 1949 }, (_, i) => now - i);
})();

const YearRangePicker = ({ from, to, onFromChange, onToChange }) => {
  const [openSide, setOpenSide] = useState(null);   // "from" | "to" | null
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!openSide) return;
    const onDocClick = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpenSide(null);
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, [openSide]);

  const renderSide = (side) => {
    const value = side === "from" ? from : to;
    const setValue = side === "from" ? onFromChange : onToChange;
    const isDisabled = (y) =>
      side === "from" ? (to && y > Number(to)) : (from && y < Number(from));

    return (
      <div className="position-relative flex-grow-1">
        <button
          type="button"
          className="w-100 d-flex justify-content-between align-items-center ev-message-card2 px-2 py-1 ev-radius-xsmall"
          onClick={() => setOpenSide((p) => (p === side ? null : side))}
        >
          <span className="ev-bold-med ev-xsmall-p-dark">
            {value || (side === "from" ? "From" : "To")}
          </span>
          <i className={`bi ${openSide === side ? "bi-chevron-down" : "bi-chevron-right"} ev-xsmall-p-dark`}></i>
        </button>

        {openSide === side && (
          <div className="ev-card-2 mt-1 py-1 px-1 ev-radius-xsmall position-absolute w-100" style={{ zIndex: 5 }}>
            <div className="d-flex flex-column gap-1 scrollable-element vh-20 p-1">
              <span
                className="ev-xsmall-p-dark px-2 py-1 d-block cursor-pointer"
                onClick={() => { setValue(""); setOpenSide(null); }}
              >
                Any year
              </span>
              {YEAR_OPTIONS.map((y) => (
                <span
                  key={y}
                  className={`ev-small-p-dark px-2 py-1 d-block ev-radius-xsmall ${
                    isDisabled(y) ? "opacity-50" : "cursor-pointer"
                  } ${String(value) === String(y) ? "ev-message-card2" : ""}`}
                  onClick={() => {
                    if (isDisabled(y)) return;
                    setValue(String(y));
                    setOpenSide(null);
                  }}
                >
                  {y}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div ref={wrapRef} className="d-flex gap-1 align-items-center mb-2">
      {renderSide("from")}
      <span className="ev-xsmall-p-dark text-nowrap">To</span>
      {renderSide("to")}
    </div>
  );
};

export default YearRangePicker;